import { render, staticRenderFns } from "./ItemListEditor.vue?vue&type=template&id=5ffca4db&scoped=true&"
import script from "./ItemListEditor.vue?vue&type=script&lang=js&"
export * from "./ItemListEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffca4db",
  null
  
)

export default component.exports